<template>
  <v-container>
    <v-row align="center" justify="center">
      <v-col cols="12" md="12" sm="12">
        <v-card v-if="showMastercardBanner">
          <div id="animContainer" v-show="showMastercardBanner">
            <mc-sonic class="child" id="mc-sonic" clear-background name="mcsonic"></mc-sonic>
          </div>
        </v-card>
        <v-card v-else>
          <div class="pa-2"
               style="background-color: #0091EA"/>
          <v-row align="center" justify="center">
            <v-col cols="10" md="10" class="text-center">
              <img
                src="@/assets/billy_success.svg" height="120"
              class="mb-2">
              <div class="mb-5">
                <h1 class="font-weight-bold headline">
                  Has enviado tu pago a {{infoPage.nombre_negocio}}
                </h1>
              </div>
              <div>
                <p>
                  Enviaste <span class="font-weight-bold">${{amount}} MXN</span>
                  {{ textWithPaymentPlans  }}
                  mediante Pagos a Distancia de Billpocket.
                </p>
                <p>El ID de tu transacción es
                  <span class="font-weight-bold">{{infoPage.opId}}</span>.</p>
              </div>
              <div class="d-flex flex-column align-center justify-center">
                <div>
                  <p class="mb-0">¿Quieres que te enviemos el recibo de tu pago?</p>
                </div>
                <v-col cols="10" md="6" class="text-center">
                  <v-tabs fixed-tabs class="mb-3">
                    <v-tab
                      @click="channel = 'email'"
                    >
                      <v-icon medium>mdi-email</v-icon> Email
                    </v-tab>
                    <v-tab
                      @click="channel = 'sms'"
                    >
                      <v-icon medium>mdi-message-text</v-icon> SMS
                    </v-tab>
                  </v-tabs>
                  <div v-if="channel === 'email'">
                    <v-form
                    ref="emailForm">
                      <v-text-field
                        label="Tu correo electrónico"
                        :rules="emailRules"
                        v-model="contact"
                        clearable
                        type="email"
                        prepend-inner-icon="email"
                      ></v-text-field>
                      <v-spacer></v-spacer>
                    </v-form>
                    <v-btn block color="secondary" class="mt-4"
                      @click="sendNotification"
                      dark type="submit">
                      <span v-show="!callingApi"> Enviar correo </span>
                      <div v-show="callingApi">
                          <v-progress-circular
                          indeterminate
                          color="white"
                        ></v-progress-circular>
                      </div>
                    </v-btn>
                  </div>
                  <div v-if="channel === 'sms'">
                    <v-form @submit.prevent="sendNotification" ref="smsForm">
                      <v-text-field
                      label="Tu número de teléfono"
                      :rules="smsRules"
                      v-model="contact"
                      clearable
                      prepend-inner-icon="message"
                    ></v-text-field>
                    <v-spacer></v-spacer>
                    <v-btn block color="secondary" class="mt-4"
                    dark type="submit">
                      <span v-show="!callingApi">Enviar SMS</span>
                      <div v-show="callingApi">
                          <v-progress-circular
                          indeterminate
                          color="white"
                        ></v-progress-circular>
                      </div>
                    </v-btn>
                    </v-form>
                  </div>
                </v-col>
              </div>
              <div class="mt-4">
                <p>
                  Ya le avisamos a <span class="font-weight-bold">{{infoPage.nombre_negocio}}</span>

                  del pago que realizaste.
                </p>
                <p>
                  Tú también puedes recibir pagos mediante Pagos a Distancia de Billpocket.
                  <a target="_self" :href="urlLanding">
                    Ver más información
                  </a>
                </p>
              </div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
    <v-snackbar
      v-model="showSnack"
      :color="colorSnack"
      :timeout="7000"
      :top="true"
    >
      {{ msgSnack }}
      <v-btn
        dark
        text
        @click="showSnack = false"
      >
        Cerrar
      </v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
export default {
  name: 'InfoPayDone',
  computed: {
    dialogWith() {
      const {
        lg, md, sm, xs,
      } = this.$vuetify.breakpoint;

      let withDialog = 600;

      if (xs) withDialog = 400;
      if (sm) withDialog = 500;
      if (md) withDialog = 550;
      if (lg) withDialog = 600;

      return withDialog;
    },
    amount() {
      const number = parseFloat(this.infoPage.monto.replace(/,/g, '')).toFixed(2);
      return number
        .toString()
        .replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    },
    textWithPaymentPlans() {
      return this.authorizedAmount !== '' ? `(Monto total a mensualidades: ${this.authorizedAmount} MXN)` : '';
    },
  },
  data: () => ({
    dialogSMS: false,
    dialogEmail: false,
    contact: null,
    channel: 'email',
    infoPage: null,
    showSnack: false,
    msgSnack: '',
    currentNotificationSelected: 'email',
    colorSnack: '',
    smsRules: [],
    emailRules: [],
    callingApi: false,
    network: '',
    played: false,
    showMastercardBanner: false,
    rules: {
      emailMatch: (value) => {
        // eslint-disable-next-line no-useless-escape
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!re.test(String(value).toLowerCase())) {
          return 'Escribe un correo válido.';
        }

        return true;
      },
      phoneMatch: (value) => {
        const re = /^\d{10}$/;
        if (!re.test(String(value).toLowerCase())) {
          return 'Escribe un teléfono a 10 dígitos.';
        }

        return true;
      },
    },
    urlLanding: process.env.VUE_APP_LANDING_PAGE,
    authorizedAmount: '',
  }),
  beforeMount() {
    const {
      externalId, total, ticketUrl, opId, email, authorizedAmount, cardBrand,
    } = this.$route.query;
    this.network = (cardBrand || '').toLocaleLowerCase();
    this.authorizedAmount = authorizedAmount || '';
    if (this.network === 'mastercard') {
      this.showMastercardBanner = true;
    }
    if (email) {
      this.contact = email;
    }
    this.infoPage = {
      nombre_negocio: externalId,
      monto: total,
      ticketUrl,
      opId,
    };
    if (this.network === 'visa' && !window.location.search.includes('r=1')) {
      window.location.href = `/visa.html${window.location.search}&r=1`;
    }
  },
  mounted() {
    if (this.showMastercardBanner) {
      this.played = true;
      const mcComponent = document.getElementById('mc-sonic');
      mcComponent.play();
      setTimeout(() => {
        this.showMastercardBanner = false;
      }, 3000);
    }
  },
  methods: {
    sendNotification() {
      const self = this;
      const payload = {
        channel: this.channel,
        id: this.infoPage.opId,
        hash: this.infoPage.ticketUrl,
      };
      if (this.channel === 'email') {
        payload.email = this.contact;
        this.emailRules = [
          (value) => {
            // eslint-disable-next-line no-useless-escape
            const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (!re.test(String(value).toLowerCase())) {
              return 'Escribe un correo válido.';
            }

            return true;
          },
          (value) => !!value || 'Campo Requerido.'];
        setTimeout(() => {
          if (self.$refs.emailForm.validate()) {
            this.callingApi = true;
            self.postAsyncNotification(payload)
              .then(() => {
                self.showSnack = true;
                self.msgSnack = '¡Listo! Te hemos enviado tu ticket.';
                self.colorSnack = 'success';
              })
              .catch(() => {
                self.showSnack = true;
                self.msgSnack = '¡Ups! Tuvimos un problema al enviarte el mensaje, intenta de nuevo.';
                self.colorSnack = 'error';
              }).finally(() => {
                self.contact = null;
                self.emailRules = [];
                this.callingApi = false;
              });
          }
        });
      } else if (this.channel === 'sms') {
        payload.phone = this.contact;
        this.smsRules = [
          (value) => {
            const re = /^\d{10}$/;
            if (!re.test(String(value).toLowerCase())) {
              return 'Escribe un teléfono a 10 dígitos.';
            }

            return true;
          },
          (value) => !!value || 'Campo Requerido.',
        ];
        setTimeout(() => {
          if (self.$refs.smsForm.validate()) {
            this.callingApi = true;
            self.postAsyncNotification(payload)
              .then(() => {
                self.showSnack = true;
                self.msgSnack = '¡Listo! Te hemos enviado tu ticket.';
                self.colorSnack = 'success';
              })
              .catch(() => {
                self.showSnack = true;
                self.msgSnack = '¡Ups! Tuvimos un problema al enviarte el mensaje, intenta de nuevo.';
                self.colorSnack = 'error';
              }).finally(() => {
                self.contact = null;
                self.smsRules = [];
                this.callingApi = false;
              });
          }
        });
      }
    },
    postAsyncNotification: async (payload) => {
      const promiseData = await fetch(`${process.env.VUE_APP_NOTIFICATION_SERVICE}`, {
        method: 'POST',
        body: JSON.stringify(payload),
        headers: {
          'Content-Type': 'application/json',
        },
      });
      const response = await promiseData.json();
      const { status } = promiseData;
      if (status !== 200) {
        throw new Error('Error notification service.');
      }
      return {
        response,
        status,
      };
    },
    mastercardSonicBrand() {
    },
  },
};
</script>
<style scoped>
  #animContainer{
    height: 400px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .child {
    width: 300px;
    height: 300px;
  }
</style>
